// extracted by mini-css-extract-plugin
export var externalLink = "_8n-0";
export var internalLinkLabel = "_8n-1";